import * as z from "../../../../framework";
import aboutView from "./about.view";

var About = function () {
    this.versionData = null;
    this.bindEvents();
};

About.prototype = {
    /*
        * BindEvents
        * Bind events needed by the report popup screen
        *
    */
    bindEvents: function () {
        var me = this;

        $("#AboutServicePro").tie("click", function () {
            z.ajax({
                type: "GET",
                url: "User/GetVersionInfo",
                headers: { "Company-Version": z.settings.companyVersion }
            }).done(function (data) {
                me.versionData = data.d.results;
                me.versionData.DefaultStackVersion = z.settings.defaultStackVersion;
                me.initAboutPopUp(me.versionData);
            });
        });
    },

    /*
        * InitReportPopUp
        * Build the report pop up screen off of templates
        *
    */
    initAboutPopUp: function (data) {
        z.settings.appSettings = z.settings.appSettings || {};
        z.LocalizedLanguage.BrandedAppName = z.LocalizedLanguage.BrandedAppName || "Service Pro";

        if (data == undefined) {
            return;
        }

        var me = this;
        var currentYear = z.util.currentYear();

        me.aboutObservable = z.observable({
            MSIData: `© ${currentYear} - ${z.settings.appSettings.appName || "Service Pro"}`,
            LearnMoreAbout: z.ll("LearnMoreAbout"),
            MSILabel: z.settings.appSettings.learnMoreAboutCompanyName || "MSI",
            MSILink: z.settings.appSettings.learnMoreAboutURL || "http://www.msidata.com",
            VersionNumber: z.ll("Version"),
            AppVersion: z.ll("AppVersion"),

            ApiServiceVersion: z.ll("ApiServiceVersion"),
            CompanyDatabaseVersion: z.ll("CompanyDatabaseVersion"),
            CoreDatabaseVersion: z.ll("CoreDatabaseVersion"),
            DefaultStackVersionLabel: z.ll("DefaultStackVersion"),
            DefaultCdnVersionLabel: z.ll("DefaultCdnVersion"),
            VersionInfoLabel: z.ll("VersionInfo"),
            StatusPage: z.ll("ViewStatusPage"),

            VNumber: "{0} {1}".format(
                z.ll("BrandedAppName"),
                data.BuildYear || currentYear
            ),
            AVersion: window.z.configuration.defaultCdnVersion,
            DefaultStackVersion: data.DefaultStackVersion,
            DefaultCdnVersion: z.settings.defaultCdnVersion,
            ApiVersion: data.ServiceCodeVersion,
            CompanyDbVersion: data.CompanyDbSchemaVersion,
            CoreDbVersion: data.CoreDbSchemaVersion,
        });

        var popUp = z.controls.popUp({
            id: "AboutWindow",
            title: z.ll("BrandedAboutInfo"),
            width: 600,
            buttons: [
            ]
        });

        var aboutLayout = aboutView();
        aboutLayout.options.zScreen = popUp;
        aboutLayout.render(popUp.guts);

        z.bind({ container: popUp.get("#AboutContainer"), bind: ".bind-value", data: me.aboutObservable });
        z.bind({ container: popUp.get("#AboutContainer"), bind: ".bind-label", data: me.aboutObservable });
    }
};

export default About;
